import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../AxiosInterceptor/axiosInterceptor";
import { configurationQueryCol } from '../../Table/TableQueryColumn';

const initialState = {
    data: {
        runId: '',
        seqNo: '',
        carrier: '',
        gpiInput: '',
        totalCount: 0,
        sortOrder: 'asc',
        columnName: 'Run Date',
        pageSize: 50,
        page: 0,
        tableData: []
    },
    search: true,
    error: false,
    isSearchClicked: false,
    inputError: {
        gpiInput: false,
    }
}

// export const getConfigurationsTableData = createAsyncThunk('data/getConfigurationsTableData', async (configurationData) => {
//     let configurationQuery = `query{


//         GetDetails(rundate11:"${configurationData.runId}",runid:"${configurationData.seqNo}",pageSize:${configurationData.pgsize},pageNumber:${configurationData.page + 1}${configurationData.gpiInput ? `,gpindc: "${configurationData.gpiInput}"` : ""
//         } sortOrder:"${configurationData.sortOrder}", columnName:"${configurationData.columnName}" `;

//     if (configurationData.carrier !== null) {
//         if (configurationData.carrier.length > 0)
//             configurationQuery += `,carrier:"${configurationData.carrier}"`;
//     }

//     configurationQuery += configurationQueryCol

//     const response = await axiosInstance.post(import.meta.env.VITE_CONFIGURATION_DETAIL,
//         JSON.stringify({ query: configurationQuery, variables: {} })
//     );
//     return JSON.stringify(response);
// });
export const getConfigurationsTableData = createAsyncThunk(
    'data/getConfigurationsTableData',
    async (configurationData, { rejectWithValue }) => {
        try {
            let configurationQuery = `query{
     

                GetDetails(rundate:"${configurationData.runId}",runid:"${configurationData.seqNo}",pageSize:${configurationData.pageSize},pageNumber:${configurationData.page + 1}${configurationData.gpiInput ? `,gpindc: "${configurationData.gpiInput}"` : ""
                } sortOrder:"${configurationData.sortOrder}", columnName:"${configurationData.columnName}" `;

            if (configurationData.carrier !== null) {
                if (configurationData.carrier.length > 0)
                    configurationQuery += `,carrier:"${configurationData.carrier}"`;
            }

            configurationQuery += configurationQueryCol

            const response = await axiosInstance.post(process.env.REACT_APP_CONFIGURATION_DETAIL,
                JSON.stringify({ query: configurationQuery, variables: {} })
            );

            if (response.data.errors && response.data.errors.length > 0) {
                const errorMessages = response.data.errors.map(err => err.message).join(', ');
                return rejectWithValue(errorMessages);
            }

            return JSON.stringify(response);
        } catch (err) {
            return rejectWithValue(err.message || 'Unexpected error');
        }
    }
);

const cnsConfigurations = createSlice({
    name: 'cnsConfigurations',
    initialState,
    reducers: {
        currentData: (state, action) => {
            state.data = action.payload
        },
        clearData: (state) => {
            state.data = initialState.data;
            state.search = true;
            state.inputError = initialState.inputError;
            state.error = initialState.error;
        },
        resetData: (state) => {
            state.data = initialState.data;
            state.search = false;
            state.inputError = initialState.inputError;
            state.error = initialState.error;
        },
        updateSearch: (state, action) => {
            state.search = action.payload;
        },
        searchClicked: (state, action) => {
            state.isSearchClicked = action.payload;
            state.error = initialState.error;
        },
        clearTable: (state, action) => {
            state.isSearchClicked = action.payload;
        },
        updateInputError: (state, action) => {
            state.inputError = action.payload
        },
        resetError: (state, action) => {
            state.inputError = initialState.inputError;
        },
        resetToaster: (state, action) => {
            state.error = initialState.error;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getConfigurationsTableData.pending, (state) => {
                state.loading = true;
                state.error = false;
            })
            .addCase(getConfigurationsTableData.fulfilled, (state, action) => {
                const response = JSON.parse(action.payload);
                state.error = false;
                state.loading = false;
                state.data.totalCount = response.data.data.GetDetails.totalCount;
                state.data.tableData = response.data.data.GetDetails.data;
            })
            .addCase(getConfigurationsTableData.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            })
    }

})

export const { currentData, clearData, updateSearch, searchClicked,
    clearTable, updateInputError, resetError, resetToaster } = cnsConfigurations.actions;
export default cnsConfigurations.reducer;